export default __webpack_public_path__ + "static/sandpit-cf2b65aff8e3e24ef194fa0f077502b1.jpg";